import { z } from 'zod';
import { vatSchema } from '../zod-schemas/schema';

export const departmentSchema = z
  .object({
    department: z.object({
      id: z.string(),
      VAT: vatSchema,
      branchOfficeId: z.string(),
      location: z.object({
        id: z.string(),
        address: z.string(),
      }),
      name: z.string(),
      billingEntity: z
        .object({
          name: z.string(),
          id: z.string(),
        })
        .nullable(),
      flexPools: z.array(
        z.object({
          directClaimAllowed: z.boolean(),
          id: z.string(),
          name: z.string(),
        })
      ),
    }),
  })
  .strip();

export type DepartmentDetailResponse = z.infer<typeof departmentSchema>;
